module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Julie Cantrell\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Julie Cantrell is a "), _c('I', [_vm._v("New York Times")]), _vm._v(" and "), _c('I', [_vm._v("USA Today")]), _vm._v(" bestselling author, editor, and TEDx speaker. Her work has received numerous awards and special recognition across both faith-based and general audiences.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/MJUpe/tc-custom/9780718037635.jpg?1726617321291",
      "alt": "This image is the cover for the book Feathered Bone"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Feathered Bone\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("“Feathers—no matter what size or shape or color—are all the same, if you think about them. They’re soft. Delicate. But the secret thing about feathers is . . . they are very strong.”")])])]), _c('p', [_c('i')]), _c('p', [_vm._v("In the pre-Katrina glow of New Orleans, Amanda Salassi is anxious about chaperoning her daughter’s sixth-grade field trip to the Big Easy during Halloween. And then her worst fears come true. Her daughter’s best friend, Sarah, disappears amid the magic and revelry—gone, without a trace.")]), _c('p', [_vm._v("Unable to cope with her guilt, Amanda’s daughter sinks into depression. And Amanda’s husband turns destructive as he watches his family succumb to grief. Before long, Amanda’s whole world has collapsed.")]), _c('p', [_vm._v("Amanda knows she has to save herself before it’s too late. As she continues to search for Sarah, she embarks on a personal journey, seeking hope and purpose in the wake of so much tragedy and loss.")]), _c('p', [_vm._v("Set amidst the murky parishes of rural Louisiana and told through the eyes of two women who confront the darkest corners of humanity with quiet and unbreakable faith, "), _c('i', [_vm._v("The Feathered Bone ")]), _vm._v("is Julie Cantrell’s master portrait of love in a fallen world.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Thomas Nelson\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0